// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"665":"6a4d9673","678":"component---src-pages-index-js"}[chunkId] + "-" + {"665":"0d518e2c6c00afd2ed17","678":"447d0410151485e245bb"}[chunkId] + ".js";
};